export default {
  setVorderDetail(state, vorderDetail) {
    state.vorderDetail = vorderDetail
  },
  setTagList(state, tagList) {
    tagList.forEach(v => {
      v.state = false
    })
    state.tagList = tagList
  },
  setNewComment(state, newComment) {
    state.newComment = { ...state.newComment, ...newComment }
  },
  setCommentDigest(state, commentDigest) {
    state.commentDigest = commentDigest
  },
  setShareComment(state, share) {
    state.shareComment = share
  },
  setShareCommentWorker(state, data) {
    state.shareCommentWorker = data
  },
  setShareKey(state, share) {
    state.shareKey = share
  },
  setCommentSettings(state, settings) {
    state.commentSettings = settings
  },
  setCommentObj(state, obj) {
    state.commentObj = { ...state.commentObj, ...obj }
  }
}
